import React, { Component } from 'react';
import get from 'lodash/get';
import PropTypes from 'prop-types';

import RichTextField from './RichTextField';
import '../../css/Table.scss';

const Cell = ({ id, columnReadOnly, tableReadOnly, ...props }) => (
  <td id={id} className={`secondary-font${columnReadOnly ? ' read-only' : ''}`}>
    <RichTextField
      {...props}
      readOnlyWorksheet={columnReadOnly || tableReadOnly}
      embedded
    />
  </td>
);

Cell.defaultProps = {
  columnReadOnly: false,
  tableReadOnly: false,
};

Cell.propTypes = {
  columnReadOnly: PropTypes.bool,
  tableReadOnly: PropTypes.bool,
};

class Table extends Component {
  render() {
    const { data, value, uuid, path, readOnlyWorksheet, ...rest } = this.props;
    return (
      <table style={{ width: '100%' }} className="mb4">
        <colgroup>
          {value.map((row, rowIndex) => (
            <col
              key={rowIndex}
              width={`${parseFloat((1 / row.length) * 100).toFixed(2)}%`}
            />
          ))}
        </colgroup>
        <tbody>
          {value.map((row, rowIndex) => (
            <tr key={rowIndex}>
              {row.map((column, columnIndex) => {
                const deepPath = [rowIndex, columnIndex, 'value'].map(String);
                return (
                  <Cell
                    key={columnIndex}
                    {...rest}
                    path={path.concat(deepPath)}
                    id={`${path}-${rowIndex}-${columnIndex}`}
                    columnReadOnly={column.readOnly}
                    tableReadOnly={readOnlyWorksheet}
                    uuid={uuid}
                    data={
                      column.readOnly
                        ? column.value
                        : get(data, deepPath, column.value)
                    }
                  />
                );
              })}
            </tr>
          ))}
        </tbody>
      </table>
    );
  }
}

Table.propTypes = {
  uuid: PropTypes.string.isRequired,
  value: PropTypes.array,
  data: PropTypes.array,
};

export default Table;
